(() => {
  'use strict';

  // Both HydroSeal selectors sell one variant per kit, including the glass kits.
  const query = `mutation BuyHydroSealKit($input: CartInput!, $language: LanguageCode) @inContext(language: $language) {
    cartCreate(input: $input) {
      cart {
        checkoutUrl
        lines(first: 2) { nodes { quantity merchandise { ... on ProductVariant { id } } } }
      }
      userErrors { message }
      warnings { message }
    }
  }`;

  async function createCheckout(variantId, signal) {
    const merchandiseId = 'gid://shopify/ProductVariant/' + variantId;
    const country = window.Shopify?.country;
    const language = (window.Shopify?.locale || document.documentElement.lang).split('-')[0].toUpperCase();
    const input = { lines: [{ merchandiseId, quantity: 1 }] };
    if (country) input.buyerIdentity = { countryCode: country };
    const response = await fetch('/api/2026-10/graphql.json', {
      method: 'POST', credentials: 'same-origin', signal,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ query, variables: { input, language: language || null } }),
    });
    if (!response.ok) return null;
    const result = await response.json();
    const created = result.data?.cartCreate;
    if (!created || result.errors?.length || created.userErrors.length || created.warnings.length) return null;
    const lines = created.cart?.lines.nodes;
    if (lines?.length !== 1 || lines[0].quantity !== 1 || lines[0].merchandise.id !== merchandiseId) return null;
    return created.cart.checkoutUrl;
  }

  window.startHydroSealCheckout = async ({ root, variantId, button, cartButtons, note, setBusy }) => {
    const enabled = [button, ...cartButtons].filter(control => control && !control.disabled);
    const buttonLabel = button.textContent;
    const selectionNote = root.dataset.activeMode === 'glass' ? root.dataset.glassNote : root.dataset.kitNote;
    setBusy(true);
    enabled.forEach(control => { control.disabled = true; });
    button.setAttribute('aria-busy', 'true');
    button.textContent = root.dataset.openingLabel;
    if (note) {
      note.classList.remove('is-error');
      note.textContent = root.dataset.openingLabel;
    }

    const unlock = () => {
      setBusy(false);
      enabled.forEach(control => { control.disabled = false; });
      button.removeAttribute('aria-busy');
      button.textContent = buttonLabel;
    };
    const controller = new AbortController();
    let timer;
    try {
      const timeout = new Promise((_, reject) => {
        timer = setTimeout(() => {
          controller.abort();
          reject(new Error('Checkout timed out'));
        }, 12000);
      });
      const url = await Promise.race([createCheckout(variantId, controller.signal), timeout]);
      if (!url) throw new Error('Incomplete checkout');
      window.location.assign(url);
      // Browsers can restore the disabled buttons along with the page from their history cache.
      const onReturn = event => {
        if (!event.persisted) return;
        window.removeEventListener('pageshow', onReturn);
        unlock();
        if (note) note.textContent = selectionNote;
      };
      window.addEventListener('pageshow', onReturn);
    } catch {
      unlock();
      if (note) {
        note.textContent = root.dataset.checkoutError;
        note.classList.add('is-error');
      }
    } finally {
      clearTimeout(timer);
    }
  };
})();
